module.exports = {
  cameraData: () => {
    return [
      {
        "MUSTANG GT PREMIUM": {
          "ADM_DifusorBalanceTrasero": {
            "x": 0,
            "y": 0.5,
            "z":  -2
          },
          "ADM_JuegoFaldonesLaterales": {
            "x": 3,
            "y": 0.8,
            "z": 0
          },
          "ADM_DivisorParachoquesDelantero": {
            "x": 0,
            "y": 1.7,
            "z": 5
          },
          "ADM_JuegoCortinasAireSatinBlack": {
            "x": 0,
            "y": 1.7,
            "z": 5
          },
          "ADM_JuegoPanelesLaterales": {
            "x": 3,
            "y": 0.8,
            "z": 0
          },
          "ADM_JuegoPanelesVentana": {
            "x": 4.7,
            "y": 3.2,
            "z": 0.1
          },
          "ADM_JuegoVentilacionCapoSatinBlack": {
            "x": 0,
            "y": 3.5,
            "z": 4.5
          },
          "ADM_SpoilerBaulMustangTechoRigido": {
            "x": 4.3,
            "y": 4.2,
            "z": -2
          },
          "ADM_SpoilerTraseroCoupe": {
            "x": 4.3,
            "y": 4.2,
            "z": -2
          }
        },
        "F-150 RAPTOR": {
          "ADM_BarraAntivuelcoNegraMate": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_CajaAlmacenamientoIzquierdo": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_CubiertaPlatonSuave": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_CubiertaPlegableCubreplaton": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_CubiertaPlegablePlaton": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_DivisorPlaton": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_MallaCarga": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_MolduraPuertas": {
            "x": 4.4,
            "y": 1,
            "z":  0.2
          },
          "ADM_SalpicaderasLlantasTraseras": {
            "x": 3,
            "y": 1.2,
            "z":  -3.8
          },
          "ADM_SpoilerCabina": {
            "x": -3.7,
            "y": 5.3,
            "z":  0.1
          },
          "ADM_SpoilerCompuertaTrasera": {
            "x": 3.6,
            "y": 4,
            "z":  -4.4
          }
        },
        "ESCAPE ECOBOOST": {
          "ADM_BarrasTecho": {
            "x": 4.4,
            "y": 3.7,
            "z":  -0.1
          },
          "ADM_EstribosNegros": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_EstribosNegrosBiselCromado": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_JuegoCortinasAire": {
            "x": -0.01,
            "y": 1,
            "z":  5.4
          },
          "ADM_JuegoMoldurasArcoRueda": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_JuegoMoldurasPuerta": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_PlacaAntideslizanteDelantera": {
            "x": -0.01,
            "y": 1,
            "z":  5.4
          },
          "ADM_PlacaAntideslizanteTrasera": {
            "x": 0.1,
            "y": 0.6,
            "z":  -5.4
          },
        },
        "ESCAPE SE 4X2 FHEV": {
          "ADM_BarrasTecho": {
            "x": 4.4,
            "y": 3.7,
            "z":  -0.1
          },
          "ADM_EstribosNegros": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_EstribosNegrosBiselCromado": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_JuegoCortinasAire": {
            "x": -0.01,
            "y": 1,
            "z":  5.4
          },
          "ADM_JuegoMoldurasArcoRueda": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_JuegoMoldurasPuerta": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_PlacaAntideslizanteDelantera": {
            "x": -0.01,
            "y": 1,
            "z":  5.4
          },
          "ADM_PlacaAntideslizanteTrasera": {
            "x": 0.1,
            "y": 0.6,
            "z":  -5.4
          },
        },
        "ESCAPE SEL 4X2 FHEV": {
          "ADM_BarrasTecho": {
            "x": 4.4,
            "y": 3.7,
            "z":  -0.1
          },
          "ADM_EstribosNegros": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_EstribosNegrosBiselCromado": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_JuegoCortinasAire": {
            "x": -0.01,
            "y": 1,
            "z":  5.4
          },
          "ADM_JuegoMoldurasArcoRueda": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_JuegoMoldurasPuerta": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_PlacaAntideslizanteDelantera": {
            "x": -0.01,
            "y": 1,
            "z":  5.4
          },
          "ADM_PlacaAntideslizanteTrasera": {
            "x": 0.1,
            "y": 0.6,
            "z":  -5.4
          },
        },
        "RANGER XL": {
          "ADM_BarraK1Cromada": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BarraK1Negra": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BedlinerPerfilSuperior": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_CapotaLonaBarraFibra": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_CapotaLonaDCAllBlack": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_EstribosTubularesCromados": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_EstribosTubularesNegros": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_KitExtensionesRuedasFenderFlares": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_MolduraCompuertaTrasera": {
            "x": 0.1,
            "y": 0.6,
            "z":  -5.4
          },
          "ADM_MoldurasCapot": {
            "x": 0.02,
            "y": 2.1,
            "z":  4.6
          },
          "ADM_PanelesPuerta": {
            "x": 4.6,
            "y": 2.3,
            "z":  -0.03
          },
          "ADM_PerfilesSuperioresLaterales": {
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_PerfilSuperiorCompuerta": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_ProtectorBumperLucesDRL": {
            "x": 0,
            "y": 1.04,
            "z":  4.8
          },
          "ADM_SpoilerCompuertaTrasera": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_SpoilerCabina": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
        },
        "RANGER XLS DIESEL": {
          "ADM_BarraK1Cromada": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BarraK1Negra": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BedlinerPerfilSuperior": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_CapotaLonaBarraFibra": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_CapotaLonaDCAllBlack": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_EstribosTubularesCromados": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_EstribosTubularesNegros": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_KitExtensionesRuedasFenderFlares": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_MolduraCompuertaTrasera": {
            "x": 0.1,
            "y": 0.6,
            "z":  -5.4
          },
          "ADM_MoldurasCapot": {
            "x": 0.02,
            "y": 2.1,
            "z":  4.6
          },
          "ADM_PanelesPuerta": {
            "x": 4.6,
            "y": 2.3,
            "z":  -0.03
          },
          "ADM_PerfilesSuperioresLaterales": {
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_PerfilSuperiorCompuerta": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_ProtectorBumperLucesDRL": {
            "x": 0,
            "y": 1.04,
            "z":  4.8
          },
          "ADM_SpoilerCompuertaTrasera": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_SpoilerCabina": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
        },
        "ESCAPE TITANIUM 4X4 FHEV": {
          "ADM_BarrasTecho": {
            "x": 4.4,
            "y": 3.7,
            "z":  -0.1
          },
          "ADM_EstribosNegros": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_EstribosNegrosBiselCromado": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_JuegoCortinasAire": {
            "x": -0.01,
            "y": 1,
            "z":  5.4
          },
          "ADM_JuegoMoldurasArcoRueda": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_JuegoMoldurasPuerta": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_PlacaAntideslizanteDelantera": {
            "x": -0.01,
            "y": 1,
            "z":  5.4
          },
          "ADM_PlacaAntideslizanteTrasera": {
            "x": 0.1,
            "y": 0.6,
            "z":  -5.4
          },
        },
        "EXPLORER LIMITED": {
          "ADM_BarrasTecho": {
            "x": 4.4,
            "y": 3.7,
            "z":  -0.1
          },
          "ADM_EstribosNegros": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_EstribosNegrosBiselCromado": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_TiroArrastre": {
            "x": 0.1,
            "y": 0.6,
            "z":  -5.4
          },
        },
        "EXPLORER XLT": {
          "ADM_BarrasTecho": {
            "x": 4.4,
            "y": 3.7,
            "z":  -0.1
          },
          "ADM_EstribosNegros": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_EstribosNegrosBiselCromado": {
            "x": 5.4,
            "y": 0.5,
            "z":  0.1
          },
          "ADM_TiroArrastre": {
            "x": 0.1,
            "y": 0.6,
            "z":  -5.4
          },
        },
        "RANGER XLT": {
          "ADM_BarraK1Cromada": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BarraK1Negra": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BedlinerSinPerfilSuperiors": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_CapotaLonaFlex": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_CapotaLonaDCAllBlack": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_EstribosTubularesCromados": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_EstribosTubularesNegros": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_KitExtensionesRuedasFenderFlares": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_MolduraCompuertaTrasera": {
            "x": 0.1,
            "y": 0.6,
            "z":  -5.4
          },
          "ADM_MoldurasCapot": {
            "x": 0.02,
            "y": 2.1,
            "z":  4.6
          },
          "ADM_PanelesPuerta": {
            "x": 4.6,
            "y": 2.3,
            "z":  -0.03
          },
          "ADM_PerfilesSuperioresLaterales": {
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_PerfilSuperiorCompuerta": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_ProtectorBumperLucesDRL": {
            "x": 0,
            "y": 1.04,
            "z":  4.8
          },
          "ADM_SpoilerCompuertaTrasera": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_SpoilerCabina": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
        },
        "RANGER LIMITED": {
          "ADM_BarraK1Cromada": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BarraK1Negra": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BedlinerPerfilSuperior": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_CapotaLonaBarraFibra": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_CapotaLonaDCAllBlack": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_EstribosTubularesCromados": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_EstribosTubularesNegros": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_KitExtensionesRuedasFenderFlares": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_MolduraCompuertaTrasera": {
            "x": 0.1,
            "y": 0.6,
            "z":  -5.4
          },
          "ADM_MoldurasCapot": {
            "x": 0.02,
            "y": 2.1,
            "z":  4.6
          },
          "ADM_PanelesPuerta": {
            "x": 4.6,
            "y": 2.3,
            "z":  -0.03
          },
          "ADM_PerfilesSuperioresLaterales": {
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_PerfilSuperiorCompuerta": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_ProtectorBumperLucesDRL": {
            "x": 0,
            "y": 1.04,
            "z":  4.8
          },
          "ADM_SpoilerCompuertaTrasera": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_SpoilerCabina": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
        },
        "BRONCO SPORT WILDTRAK": {
          "ADM_BarraK1Cromada": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BarraK1Negra": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BedlinerPerfilSuperior": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_CapotaLonaBarraFibra": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_CapotaLonaDCAllBlack": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "BDM_KitExtensionesRuedasFenderFlares": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_KitExtensionesRuedasFenderFlares": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_KitExtensionesRuedasFenderFlaresFord": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_SalpicaderasLlantasDelanteras": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_SalpicaderasLlantasTraseras": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_ProtectorBumperTrasero": {
            "x": 0.1,
            "y": 0.6,
            "z":  -5.4
          },
          "ADM_ProtectorCapo": {
            "x": 0.02,
            "y": 2.1,
            "z":  4.6
          },
          "ADM_TomaAireCapo": {
            "x": 0.02,
            "y": 2.1,
            "z":  4.6
          },
          "ADM_MoldurasPuertas": {
            "x": 4.6,
            "y": 2.3,
            "z":  -0.03
          },
          "ADM_PerfilesSuperioresLaterales": {
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_PerfilSuperiorCompuerta": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_ProtectorBumperLucesDRL": {
            "x": 0,
            "y": 1.04,
            "z":  4.8
          },
          "ADM_SpoilerCompuertaTrasera": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_SpoilerTecho": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BarrasTecho": {
            "x": 4.4,
            "y": 3.7,
            "z":  -0.1
          },
        },
        "BRONCO SPORT BIG BEND": {
          "ADM_BarraK1Cromada": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BarraK1Negra": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BedlinerPerfilSuperior": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_CapotaLonaBarraFibra": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_CapotaLonaDCAllBlack": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "BDM_KitExtensionesRuedasFenderFlares": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_KitExtensionesRuedasFenderFlares": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_KitExtensionesRuedasFenderFlaresFord": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_SalpicaderasLlantasDelanteras": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_SalpicaderasLlantasTraseras": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_ProtectorBumperTrasero": {
            "x": 0.1,
            "y": 0.6,
            "z":  -5.4
          },
          "ADM_ProtectorCapo": {
            "x": 0.02,
            "y": 2.1,
            "z":  4.6
          },
          "ADM_TomaAireCapo": {
            "x": 0.02,
            "y": 2.1,
            "z":  4.6
          },
          "ADM_MoldurasPuertas": {
            "x": 4.6,
            "y": 2.3,
            "z":  -0.03
          },
          "ADM_PerfilesSuperioresLaterales": {
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_PerfilSuperiorCompuerta": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_ProtectorBumperLucesDRL": {
            "x": 0,
            "y": 1.04,
            "z":  4.8
          },
          "ADM_SpoilerCompuertaTrasera": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_SpoilerTecho": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BarrasTecho": {
            "x": 4.4,
            "y": 3.7,
            "z":  -0.1
          },
        },
        "RANGER XL CHASIS": {
          "ADM_BarraK1Cromada": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BarraK1Negra": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_BedlinerPerfilSuperior": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_CapotaLonaBarraFibra": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_CapotaLonaDCAllBlack": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_EstribosTubularesCromados": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_EstribosTubularesNegros": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_ExtensionesRueda2Chasis": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_MolduraCompuertaTrasera": {
            "x": 0.1,
            "y": 0.6,
            "z":  -5.4
          },
          "ADM_MoldurasCapot": {
            "x": 0.02,
            "y": 2.1,
            "z":  4.6
          },
          "ADM_PanelesPuerta": {
            "x": 4.6,
            "y": 2.3,
            "z":  -0.03
          },
          "ADM_PerfilesSuperioresLaterales": {
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_PerfilSuperiorCompuerta": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_ProtectorBumperLucesDRL": {
            "x": 0,
            "y": 1.04,
            "z":  4.8
          },
          "ADM_SpoilerCompuertaTrasera": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
          "ADM_SpoilerCabina": {
            "x": 0,
            "y": 3.1,
            "z":  -4.15
          },
        },
        "F-150 LARIAT SPORT": {
          "ADM_BarraAntivuelcoNegraMate": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_CajaAlmacenamientoIzquierdo": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_CubiertaPlatonSuave": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_CubiertaPlegableCubreplaton": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_CubiertaPlegablePlaton": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_DivisorPlaton": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_MallaCarga": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_MolduraCompuertaTrasera": {
            "x": -0.1,
            "y": 2.3,
            "z":  -4.7
          },
          "ADM_MolduraPuertas": {
            "x": 4.4,
            "y": 1,
            "z":  0.2
          },
          "ADM_TomaAireCapo": {
            "x": 0.02,
            "y": 2.1,
            "z":  4.6
          },
          "ADM_SalpicaderasLlantasTraseras": {
            "x": 3,
            "y": 1.2,
            "z":  -3.8
          },
          "ADM_SalpicaderasLlantasDelanteras": {
            "x": 3,
            "y": 1.2,
            "z":  -3.8
          },
          "ADM_SpoilerCabina": {
            "x": -3.7,
            "y": 5.3,
            "z":  0.1
          },
          "ADM_SpoilerCompuertaTrasera": {
            "x": 3.6,
            "y": 4,
            "z":  -4.4
          },
          "ADM_KitExtensionesRuedasFenderFlares": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_KitExtensionesRuedasFenderFlaresFord": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_PuntaEscapeCromada3": {
            "x": -0.1,
            "y": 1,
            "z":  -4.7
          },
          "ADM_PuntaEscapeCromada2": {
            "x": -0.1,
            "y": 1,
            "z":  -4.7
          },
        },
        "F-150 PLATINUM FHEV": {
          "ADM_BarraAntivuelcoNegraMate": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_CajaAlmacenamientoIzquierdo": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_CubiertaPlatonSuave": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_CubiertaPlegableCubreplaton": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_CubiertaPlegablePlaton": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_DivisorPlaton": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_MallaCarga": {
            "x": -0.1,
            "y": 3.3,
            "z":  -4.7
          },
          "ADM_MolduraCompuertaTrasera": {
            "x": -0.1,
            "y": 2.3,
            "z":  -4.7
          },
          "ADM_MolduraPuertas": {
            "x": 4.4,
            "y": 1,
            "z":  0.2
          },
          "ADM_TomaAireCapo": {
            "x": 0.02,
            "y": 2.1,
            "z":  4.6
          },
          "ADM_SalpicaderasLlantasTraseras": {
            "x": 3,
            "y": 1.2,
            "z":  -3.8
          },
          "ADM_SalpicaderasLlantasDelanteras": {
            "x": 3,
            "y": 1.2,
            "z":  -3.8
          },
          "ADM_SpoilerCabina": {
            "x": -3.7,
            "y": 5.3,
            "z":  0.1
          },
          "ADM_SpoilerCompuertaTrasera": {
            "x": 3.6,
            "y": 4,
            "z":  -4.4
          },
          "ADM_KitExtensionesRuedasFenderFlares": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_KitExtensionesRuedasFenderFlaresFord": {
            "x": 4.6,
            "y": 1.9,
            "z":  -0.03
          },
          "ADM_PuntaEscapeCromada3": {
            "x": -0.1,
            "y": 1,
            "z":  -4.7
          },
          "ADM_PuntaEscapeCromada2": {
            "x": -0.1,
            "y": 1,
            "z":  -4.7
          },
        },
      }
    ]
  }
}